"use strict";

exports.__esModule = true;
exports.HelpButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _HelpContext = require("./HelpContext");
var _excluded = ["topic", "help"];
var _dec, _class, _HelpButton;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * A button which will select the given help topic when clicked.
 */
var HelpButton = exports.HelpButton = (_dec = _HelpContext.HelpContext.withContext, _dec(_class = (_HelpButton = /*#__PURE__*/function (_Component) {
  function HelpButton() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleClick = function () {
      var _this$props = _this.props,
        help = _this$props.help,
        topic = _this$props.topic;
      help.setTopic(topic);
    };
    return _this;
  }
  _inheritsLoose(HelpButton, _Component);
  var _proto = HelpButton.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props2 = this.props,
      topic = _this$props2.topic,
      help = _this$props2.help,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
      icon: _icons.IconNames.HELP,
      onClick: this.handleClick
    }, extra));
  };
  return HelpButton;
}(_react.Component), _HelpButton.defaultProps = {
  help: undefined
}, _HelpButton)) || _class);